import React from "react";
import Typography from "@mui/material/Typography";

function PromptText({ text, atTop = false }) {
  return (
    <Typography
      variant="body1"
      align="center"
      sx={{
        fontWeight: 500,
        fontStyle: "italic",
        fontFamily: "inherit",
        letterSpacing: "-0.01em",
        lineHeight: 1.55,
        color: "text.primary",
        px: 0.5,
        mx: "auto",
        maxWidth: atTop ? "100%" : 420,
        fontSize: atTop
          ? { xs: "1rem", sm: "1.05rem" }
          : { xs: "1.12rem", sm: "1.22rem" },
      }}
    >
      {text}
    </Typography>
  );
}

export default PromptText;
